import { render, staticRenderFns } from "./BundlingWechat.vue?vue&type=template&id=737a22d2&scoped=true"
import script from "./BundlingWechat.vue?vue&type=script&lang=js"
export * from "./BundlingWechat.vue?vue&type=script&lang=js"
import style0 from "./BundlingWechat.vue?vue&type=style&index=0&id=737a22d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737a22d2",
  null
  
)

export default component.exports